import { useInfiniteQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { Api } from '@/core/api';
import { formatJalali } from '@/core/jalali';

const TYPE_FA: Record<string, string> = {
  profile_created: 'شروع',
  assessed: 'ارزیابی',
  practice_logged: 'تمرین',
  reverted: 'برگشت',
  lost: 'از دست رفته',
  note_added: 'یادداشت',
  plan_changed: 'برنامه',
  share_code_created: 'اشتراک',
  grant_given: 'دسترسی',
  grant_revoked: 'قطع دسترسی',
  member_added: 'عضو',
  member_removed: 'عضو',
  ownership_transferred: 'مالکیت',
  policy_changed: 'سیاست',
  profile_imported: 'انتقال',
};

export function TimelinePage() {
  const { id } = useParams({ from: '/authed/p/$id' });
  const q = useInfiniteQuery({
    queryKey: ['timeline', id],
    queryFn: ({ pageParam }) =>
      Api.timeline(id, { before: pageParam ? String(pageParam) : undefined, limit: '40' }),
    initialPageParam: 0 as number,
    getNextPageParam: (last) => last.nextBefore ?? undefined,
  });
  const entries = q.data?.pages.flatMap((p) => p.entries) ?? [];
  return (
    <main className="page">
      <h2 className="page-title">خط زمان</h2>
      <p className="help">
        هر چیزی که روی این پروفایل ثبت شده، با نام ثبت‌کننده و تاریخ. هیچ‌چیز پاک نمی‌شود.
      </p>
      {q.isLoading && <div className="skeleton" />}
      <ol
        style={{
          listStyle: 'none',
          padding: 0,
          margin: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        {entries.map((e) => (
          <li key={e.seq} className="card" style={{ padding: 12, gap: 4 }}>
            <div className="row spread">
              <span className="chip">{TYPE_FA[e.type] ?? e.type}</span>
              <span className="help">{formatJalali(e.at)}</span>
            </div>
            <div>{e.summary}</div>
            {typeof e.payload.note === 'string' && e.payload.note && (
              <div className="help">«{e.payload.note}»</div>
            )}
            {typeof e.payload.text === 'string' && e.payload.text && (
              <div className="help">«{e.payload.text}»</div>
            )}
          </li>
        ))}
      </ol>
      {q.hasNextPage && (
        <button
          type="button"
          className="btn quiet block"
          disabled={q.isFetchingNextPage}
          onClick={() => void q.fetchNextPage()}
        >
          قدیمی‌ترها
        </button>
      )}
    </main>
  );
}
